export default [
	// {
	// 	route: {
	// 		backend: 'hyperion.finances.bank.show',
	// 		report: ''
	// 	},
	// 	icon: 'project',
	// 	text: 'Overview'
	// },
	{
		route: {
			backend: 'hyperion.finances.bank.mutation',
			report: ''
		},
		icon: 'line-chart',
		text: 'Mutations'
	}
]
